import ValidatorInterface from './ValidatorInterface';
import DataVariableInterface from "../../DataVariables/ts/DataVariableInterface";

export default abstract class Validator implements ValidatorInterface {

    private valueCount: number;
    private nullCount: number;
    private errorMessages: Array<string>;
    private errorCount: number;
    private valuePercent: number;
    protected dataVariable: DataVariableInterface;

    public constructor(dataVariable: DataVariableInterface) {
        this.errorCount = 0;
        this.valueCount = 0;
        this.nullCount = 0;
        this.errorMessages = [];
        this.valuePercent = 0;
        this.dataVariable = dataVariable;
    }

    /**
     * Validation check abstract method
     *
     * @param {string} value
     * @param {number} index
     * @param {number} offset
     * @returns {boolean}
     */

    public abstract check(value: string, index: number, offset: number): boolean;

    /**
     * Validate
     *
     * @param {string} value
     * @param {number} index
     * @param {number} offset
     */
    public validate(value: string, index: number, offset: number = 0): void {

        // Trim any white spaces automatically
        value = value.trim();
        if (!this.isBlankValue(value)) this.check(value, index, offset);
    }

    /**
     * Check if value is integer
     *
     * @param value
     * @param index
     */
    protected checkInteger(value: string, index: number): boolean {

        if (!Number.isInteger(Number(value))) {
            this.addError("Value is not integer.", index, value);
            return false;
        }
        return true;
    }

    /**
     * Check if value is string
     * @param s
     */
    protected isString(s: any): boolean {
        return typeof s === 'string';
    }

    /**
     * Check if value is numeric
     *
     * @param n
     */
    protected isNumeric(n: any): boolean {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    /**
     * Recalculate values percentage (value vs. null percent)
     */

    private recalculateValuesPercentage() {
        this.valuePercent = Math.round(this.valueCount / (this.valueCount + this.nullCount) * 100);
    }

    /**
     * Add validation error
     *
     * @param {string} message
     * @param {number} index
     * @param {string} value
     */
    public addError(message: string, index: number, value: string) {
        if (this.errorCount < 100) {
            this.errorMessages.push("Line " + (index + 2) + ": " + message + ". Error value: " + value);
        }

        this.errorCount++;
    }

    /**
     * Is value inspected blank i.e. should it be validated?
     *
     * @param {string} value
     * @returns {boolean}
     */
    private isBlankValue(value: string): boolean {
        if (value.length >= 1) {
            this.valueCount++;
            return false;
        } else {
            this.nullCount++;
            return true;
        }
    }

    /**
     * Has errors
     *
     * @returns {boolean}
     */

    public hasErrors() {
        return this.errorCount > 0;
    }

    /**
     * Get Error count
     *
     * @returns {number}
     */

    public getResults() {

        this.recalculateValuesPercentage();

        return {
            errorCount: this.errorCount,
            valueCount: this.valueCount,
            nullCount: this.nullCount,
            valuePercent: this.valuePercent,
            errorMessages: this.errorMessages,
        }
    }
}